import AddInvoiceModal from './AddInvoiceModal';

export default AddInvoiceModal;
